export default {
      id: "ic_doc_telecharger-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_doc_telecharger-usage",
      toString: function () {
        return this.url;
      }
    }